var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "22px",
    height: "21px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -304 -37 )"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 304.5 37.5  L 325.5 37.5  L 325.5 57.5  L 304.5 57.5  L 304.5 37.5  Z ",
    fillRule: "nonzero",
    fill: "#f2f2f2",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 304.5 37.5  L 325.5 37.5  L 325.5 57.5  L 304.5 57.5  L 304.5 37.5  Z ",
    strokeWidth: 1,
    stroke: "#797979",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 304.378900523123 37.3616777720718  L 325.621099476877 57.6383222279282  M 325.621099476877 37.3616777720718  L 304.378900523123 57.6383222279282  ",
    strokeWidth: 1,
    stroke: "#797979",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultIcon);
export default __webpack_public_path__ + "static/media/default_icon.ec25b0826f7fca8597c4dc50d17c1795.svg";
export { ForwardRef as ReactComponent };